import LzCrudModel from "../../../../../models/crud";
import LzCrudModelField from "../../../../../models/crud/field";

export const crudConfig = new LzCrudModel({
    ident: 'orders',
    baseRoute: '/content/orders',
    fields: {
        order_id: { size: 10, type: LzCrudModelField.TYPE_STRING, required: true },
        customer_name: { size: 100, type: LzCrudModelField.TYPE_STRING, required: false },
        distributor_name: { size: 100, type: LzCrudModelField.TYPE_STRING, required: false },
        is_active: { type: LzCrudModelField.TYPE_BOOLEAN, default: true },
    },
    listingColumns: {
        order_id: { label: 'Order #', sortable: true, alignment: 'left' },
        customer_name: { label: 'Customer', sortable: true, alignment: 'left' },
        distributor_name: { label: 'Distributor', sortable: true, alignment: 'left' },
    },
    addFormInputs: {
    },
    editFormInputs: {
    },
    showView: false,
    showStatus: false,
});
